import { TFunction } from "i18next";

import { showGlobalToast } from "@/utils/showGlobalToast";

/**
 * "Kept on the blacklist because they unsubscribed: Ada Lovelace, Ben Bit" — or null when a
 * removal kept nobody (PREC-2548). An unsubscribe is never removed; the API names the rows it left.
 */
export const describeKeptUnsubscribes = (
	skipped: { name: string }[] | null | undefined,
	t: TFunction
): string | null =>
	skipped && skipped.length > 0
		? t("contacts.blacklist.keptUnsubscribed", {
				names: skipped.map(({ name }) => name).join(", "),
			})
		: null;

/**
 * Tells the user which selected rows a removal left on the blacklist, so a bulk removal that
 * quietly skipped someone is not read as having removed everyone.
 */
export const showKeptUnsubscribesToast = (
	skipped: { name: string }[] | null | undefined,
	t: TFunction
): void => {
	const message = describeKeptUnsubscribes(skipped, t);

	if (message) {
		showGlobalToast(message, 8000);
	}
};
